import React from 'react'

 const Typing = () => {
    return (
        <div style={{padding:'1em 1em'}}>
<div className="dot-elastic">   
        </div>
        
        </div>
    )
}


export default Typing